import Polygon from "@arcgis/core/geometry/Polygon";
import * as geometryEngine from "@arcgis/core/geometry/geometryEngine";

export const calculateTotalArea = (featureSet: __esri.FeatureSet | null) => {
  if (!featureSet) return null;
  let totalArea = 0;
  const totalPoints = featureSet.features.length;

  let totalAreaGeodesic = 0;
  featureSet.features.forEach((feature) => {
    totalArea += feature.attributes.Shape__Area;
    totalAreaGeodesic += geometryEngine.geodesicArea(
      feature.geometry as Polygon,
      "square-kilometers",
    );
  });

  // Calculate average area
  // const totalAreaKm2 = totalArea / 1_000_000;
  // const averageAreaKm2 = totalAreaKm2 / features.length;
  // const averageAreaKm2Rounded = parseFloat(averageAreaKm2.toFixed(1));
  const averageAreaKm2Geodesic = totalAreaGeodesic / featureSet.features.length;
  const averageAreaKm2GeodesicRounded = Number.parseFloat(
    averageAreaKm2Geodesic.toFixed(1),
  );
  return {
    averageAreaKm2GeodesicRounded,
    totalPoints,
    totalArea,
  };
};
